import React, { Component } from 'react'
import { Redirect, Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Loader from 'react-loader'
import * as sessionActions from '../../actions/sessionActions'
import SettingsForm from 'components/forms/SettingsForm'
import { Container, Row, Col } from 'reactstrap'
import { emptyFields } from 'actions/uiActions'
import defaultAvatar from 'assets/img/avatar.png'

const AVAILABLE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg']
const MAX_SIZE = 2e6

class SettingsPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      files: [],
      imgPath: defaultAvatar,
      imageDidChange: false,
      info: {
        firstName: '',
        lastName: '',
      },
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.currentUser && nextProps.currentUser.first_name) {
      return {
        info: {
          firstName: nextProps.currentUser.first_name,
          lastName: nextProps.currentUser.last_name,
        },
      }
    }
    return prevState
  }

  componentDidMount() {
    this.props.actions.getAccountSettings()
  }

  onDropAccepted = files => {
    this.setState({
      files,
      imgPath: URL.createObjectURL(files[0]), //TODO сделать обновление аватара
    })
  }

  onDropRejected = file => {
    if (AVAILABLE_TYPES.indexOf(file.type) === -1) {
      this.props.invalidAvatar(
        'Неверный формат изображения(доступные форматы: png, gif, jpg, jpeg'
      )
    } else if (file.size >= MAX_SIZE) {
      this.props.invalidAvatar('Максимальный размер файла: 2МБ')
    }
  }

  onChange = event => {
    const field = event.target.name
    const info = this.state.info
    info[field] = event.target.value
    if (field === 'name') this.setState({ imageDidChange: true })
    return this.setState({ info })
  }

  onClick = event => {
    event.preventDefault()
    const image = this.state.imageDidChange ? this.state.files[0] : null
    if (this.state.info.firstName === '' || this.state.info.lastName === '') {
      this.props.emptyFields('Пожалуйста заполните все поля')
    } else {
      this.props.actions.registerAccount(
        this.state.info.firstName,
        this.state.info.lastName,
        image
      )
    }
  }

  render() {
    if (!this.props.jwt) return <Redirect to="/login" />
    if (this.props.userStatus !== 'activated') {
      return <Redirect to="/" />
    } else {
      return (
        <Container
          fluid
          className="d-flex justify-content-center flex-column h-100 dark-blue"
        >
          <Loader
            loaded={
              this.props.currentUser && this.props.currentUser.first_name
                ? true
                : false
            }
          >
            <Row className="align-items-center justify-content-center user-detail">
              <Col md={{ size: 5 }}>
                <SettingsForm
                  onDropAccepted={this.onDropAccepted}
                  onDropRejected={this.onDropRejected}
                  onChange={this.onChange}
                  firstName={this.state.info.firstName}
                  lastName={this.state.info.lastName}
                  onClick={this.onClick}
                  currentUser={this.props.currentUser}
                  imgPath={this.state.imgPath}
                  err={this.props.err}
                  buttonText="Обновить данные"
                />
              </Col>
            </Row>
            <Row className="align-items-center justify-content-center">
              <Col md={{ size: 'auto' }}>
                <Link className="text-warning" to="/">
                  Вернуться на главную
                </Link>
              </Col>
            </Row>
          </Loader>
        </Container>
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    currentUser: state.session.currentUser,
    jwt: state.session.jwt,
    userStatus: state.session.userStatus,
    err: state.ui.err,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
    emptyFields: msg => dispatch(emptyFields(msg)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPage)



// WEBPACK FOOTER //
// ./src/components/settings/SettingsPage.js